import BaseLoadingIndicator from 'features/room/components/BaseLoadingIndicator';
import { UnbrandedLayout } from 'layouts';

const RoomLoading = () => (
  <UnbrandedLayout>
    <BaseLoadingIndicator />
  </UnbrandedLayout>
);
export default RoomLoading;
